import React from 'react'
import cx from 'classnames'

import styles from './Card.module.scss'

export const Card = ({ children, className = undefined, tagName = null }) => {
  const Component = tagName ?? 'div'

  return (
    <Component className={cx(styles.card, { [className]: Boolean(className) })}>
      {children}
    </Component>
  )
}
